import * as React from 'react';
import { HiddenInput } from "soprasteria-ui-library";
import { IEmergencyTreatmentReport, IEmergencyTreatmentsModel } from "../../../models/IEmergencyTreatment";
import { AccountableCareProviderSection } from "./AccountableCareProviderSection";
import { TreatingCareProviderSection } from "./TreatingCareProviderSection";
import { EmergencyTreatmentOtherInfo } from "./EmergencyTreatmentOtherInfo";
import { EmergencyTreatmentReportInfo } from "./EmergencyTreatmentReportInfo";
import { EmergencyTreatments } from './EmergencyTreatments';
import { PatientInformationSection } from './PatientInformationSection';
import { IPatient } from '../../../models/IPatient';
import { isInRole, UserContext } from '../../../contexts/UserContext';
import { ALLMÄNTANDVÅRDBAS, LIBRETTOADMIN, VÅRDANSVARIG } from '../../../utils/RoleConstants';
import { EventLog } from "../../../components/EventLog/EventLog";

interface IEmergencyTreatmentFormInputs {
    emergencyTreatmentReport?: IEmergencyTreatmentReport;
    patient: IPatient;
    reportedTreatments: IEmergencyTreatmentsModel | undefined;
    updateReportedTreatments: (treatments: IEmergencyTreatmentsModel) => void;
}

export const EmergencyTreatmentFormInputs: React.FunctionComponent<IEmergencyTreatmentFormInputs> = ({ emergencyTreatmentReport, patient, reportedTreatments, updateReportedTreatments }) => {
    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles ? userInfo.roles : []);
    const hasRoleParaply = isInRole(VÅRDANSVARIG, userInfo.roles ? userInfo.roles : []);
    const hasRoleAllmantandvard = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles ? userInfo.roles : []);

    return (
        <>
            {
                emergencyTreatmentReport?.emergencyTreatmentId ?
                    <HiddenInput name="id" value={emergencyTreatmentReport.emergencyTreatmentId.toString()} />
                    : null
            }

            <EmergencyTreatmentReportInfo emergencyTreatment={emergencyTreatmentReport} />
            <hr />
            <PatientInformationSection patient={patient} />
            <hr />
            <AccountableCareProviderSection careProvider={emergencyTreatmentReport?.accountableCareProvider} />
            <hr />
            <TreatingCareProviderSection emergencyTreatmentReport={emergencyTreatmentReport} />
            <hr />
            <EmergencyTreatmentOtherInfo emergencyTreatmentReport={emergencyTreatmentReport} />
            {
                emergencyTreatmentReport?.canAddPatientTreatment || hasRoleSystemAdmin || hasRoleParaply || hasRoleAllmantandvard ?
                    <>
                        <hr />
                        <EmergencyTreatments emergencyTreatmentReportId={emergencyTreatmentReport?.emergencyTreatmentId} canAddPatientTreatment={emergencyTreatmentReport ? emergencyTreatmentReport.canAddPatientTreatment : false} reportedTreatments={reportedTreatments} updateReportedTreatments={updateReportedTreatments} />
                    </>
                    : null
            }
            <hr />
            {
                emergencyTreatmentReport?.events ?
                    <>
                        <EventLog id="emergencyTreatmentReportEventLog" events={emergencyTreatmentReport.events} />
                    </>
                    : null
            }
        </>
    )
}

